<app-company-info
  [companyInitials]="companyInitials"
  [company]="company"
></app-company-info>
<div class="header-wrapper">
  <!-- Header Tabs -->
  <mat-tab-group
    (selectedIndexChange)="onChangeTab($event)"
    [selectedIndex]="selectedTab.id"
    animationDuration="0ms"
  >
    @for (tab of tabs; track tab) {
      @if (tab.name !== 'Subscriptions' || (tab.name === 'Subscriptions' && userHasAccess)) {
      <mat-tab
        [label]="tab.name"
      >
      </mat-tab>
      }
    }
  </mat-tab-group>

  <mat-card  [class.no-evevation]="selectedTab.id === 0 ">
    <mat-card-content>
        @if (selectedTab.id === 0) {
        <app-company-dashboard
          (tabActive)="goToUser($event)"
          (subscriptionTabActive)="goToSubscriptionTab($event)"
          [usersProfile]="usersProfile"
        >
        </app-company-dashboard>
        }
        @if (selectedTab.id === 1) {
        <app-company-branches
          [branches]="companyBranches"
        >
        </app-company-branches>
        }
        @if (selectedTab.id === 2) {
        <app-company-users
          [companyId]="accountId"
          [companyBranches]="branches"
          [usersProfile]="usersProfile"
        >
        </app-company-users>
        }
        @if (selectedTab.id === 3) {
        <app-company-invites
          [usersProfile]="usersProfile"
          [inviteList]="invitationSub"
          [companyId]="accountId"
          [companyBranches]="companyBranches"
        >
        </app-company-invites>
        }
    </mat-card-content>
  </mat-card>
  @if (selectedTab.id === 4 && userHasAccess) {
  <app-company-subscription
    [companyId]="accountId"
  >
  </app-company-subscription>
  }
</div>
@if (
    (userService.loading && selectedTab.id !== 0) ||
    (selectedTab.id === 0 && userService.loading && company?.employeeCount >= 0)
  ) {
<app-spinner>
</app-spinner>
}
